import React from 'react';
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import Home from "./Home";
import { CookieSetting } from "cookiesetting-component";
const App = () => {

  const appVersion = appversion.version;
  const isProduction = process.env.NODE_ENV === "production";
  return (
    <>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={isProduction}
        isVerboseMode={false}
        metaFileDirectory={"."}
      >
        <Home />
        <CookieSetting 
           privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
           configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
           analytics={process.env.REACT_APP_ANALYTICS_PATH}
         />
      </CacheBuster>
   
    </>
  );
};

export default App;
